var render, staticRenderFns
import script from "./grid.js?vue&type=script&lang=js&external"
export * from "./grid.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=1af3a98d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af3a98d",
  null
  
)

export default component.exports